import React from 'react';
import './App.css';
import AnniversarySurprise from './components/AnniversarySurprise';

function App() {
  return (
    <div className="App">
      <AnniversarySurprise />
    </div>
  );
}

export default App;